import { render, staticRenderFns } from "./TradeInSaleableChoice.vue?vue&type=template&id=1657c53f"
import script from "./TradeInSaleableChoice.vue?vue&type=script&lang=js"
export * from "./TradeInSaleableChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports